import { render, staticRenderFns } from "./QuizUpdateForm.vue?vue&type=template&id=20adad42&"
import script from "./QuizUpdateForm.vue?vue&type=script&lang=js&"
export * from "./QuizUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports